import TimeSpent from "./TimeSpent.model";
import EventTotals from "./EventTotals.model";

const staticLayerTypes = {
  TIME_SPENT: "TIME_SPENT",
  EVENT_TOTALS: "EVENT_TOTALS",
};

export { TimeSpent, EventTotals, staticLayerTypes };
